import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customItems = null }) => {
  const location = useLocation();

  const generateBreadcrumbs = () => {
    if (customItems) {
      return customItems;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/homepage' }];

    const pathMap = {
      'blog-listing': 'Blog',
      'blog-post-detail': 'Post Detail',
      'admin-dashboard': 'Dashboard',
      'admin-posts-management': 'Posts Management',
      'admin-post-editor': 'Post Editor'
    };

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = pathMap?.[segment] || segment?.split('-')?.map(word => 
        word?.charAt(0)?.toUpperCase() + word?.slice(1)
      )?.join(' ');
      
      breadcrumbs?.push({
        label,
        path: currentPath
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <nav className="breadcrumb-navigation" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2 flex-wrap">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          
          return (
            <li key={crumb?.path} className="flex items-center gap-2">
              {index > 0 && (
                <Icon 
                  name="ChevronRight" 
                  size={16} 
                  className="breadcrumb-separator" 
                />
              )}
              {isLast ? (
                <span className="breadcrumb-current" aria-current="page">
                  {crumb?.label}
                </span>
              ) : (
                <Link 
                  to={crumb?.path} 
                  className="breadcrumb-link"
                >
                  {crumb?.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;